const coursetypegroups = {
	title: "Kompetanseområder",
	new_coursetypegroup: "Nytt kompetanseområde",
	edit_coursetypegroup: "Rediger kompetanseområde",
	view_coursetypegroup: "Vis kompetanseområde",
	list_title: "Kompetanseområder",
	list_subtitle: "Håndtere kompetanseområder",
	create_title: "Opprett kompetanseområde",
	update_title: "Endre kompetanseområde",
	details_title: "kompetanseområde detaljer",
	id: "ID",
	name: "Navn",
	category: "Kategori",
	status: "Status",
	type: "Type",
	available_to_all: "Etterregistrert/digitalisert kompetanse",
	coursetype_mandatory: "Obligatorisk kompetanse valg",
};
export default coursetypegroups;